import { graphql, useStaticQuery } from 'gatsby'
import { useSiteId } from './useSiteId'

export const useTranslations = () => {
  const siteId = useSiteId()
  const {
    craftContent: { entries },
  } = useStaticQuery(graphql`
    {
      craftContent {
        entries(
          type: "translations"
          section: "translations"
          siteId: [1, 2, 3]
        ) {
          siteId
          ... on CraftContent_translations_translations_Entry {
            translations {
              key
              text
            }
          }
        }
      }
    }
  `)

  const entry = entries.find(e => e.siteId === siteId)

  const translations = entry.translations.reduce(
    (prev, cur) => ({ ...prev, [cur.key]: cur.text }),
    {},
  )

  return translations
}
